import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { interaction_arrows_chevronUp } from '@lsg/icons';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { HeadlinePresentation } from '../Headline/HeadlinePresentation.js';
import { IconPresentation } from '../Icon/IconPresentation.js';
import { hostClass } from './Accordion.styles.js';

var defaultProps = {
  onChange: function onChange() {
    /* empty */
  },
  actionRef: function actionRef() {
    /* empty */
  },
  onMouseHoverChange: function onMouseHoverChange() {
    /* empty */
  },
  onKeyboardFocusChange: function onKeyboardFocusChange() {
    /* empty */
  }
};
var AccordionPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2, _cleanupClassObject3;
  var id = props.id,
    children = props.children,
    className = props.className,
    noMargin = props.noMargin,
    title = props.title,
    isOpen = props.isOpen,
    onChange = props.onChange,
    onKeyDown = props.onKeyDown,
    actionRef = props.actionRef,
    hasMouseHover = props.hasMouseHover,
    hasKeyboardFocus = props.hasKeyboardFocus,
    onMouseHoverChange = props.onMouseHoverChange,
    onKeyboardFocusChange = props.onKeyboardFocusChange,
    titleAs = props.titleAs;
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__closed"), !isOpen), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject))
  }, /*#__PURE__*/React.createElement("dt", {
    id: id,
    role: "heading",
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-header"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-header__hover"), hasMouseHover), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-header__focus"), hasKeyboardFocus), _defineProperty(_cleanupClassObject2, className, !!className), _cleanupClassObject2)),
    "aria-level": 3
  }, /*#__PURE__*/React.createElement(ActionPresentation, {
    id: "".concat(id, "-header-btn"),
    fullWidth: true,
    className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-header-action"), true), _defineProperty(_cleanupClassObject3, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject3)),
    onClick: function onClick(event) {
      onChange(!isOpen, id, event);
    },
    htmlAttrs: {
      "aria-expanded": isOpen,
      "aria-controls": "".concat(id, "-content")
    },
    onKeyDown: onKeyDown,
    ref: actionRef,
    onMouseHoverChange: onMouseHoverChange,
    onKeyboardFocusChange: onKeyboardFocusChange
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-header-inner")
  }, /*#__PURE__*/React.createElement(HeadlinePresentation, {
    as: titleAs || "h3",
    size: "h4",
    noMargin: true,
    className: "".concat(hostClass, "-header-text")
  }, title), /*#__PURE__*/React.createElement(IconPresentation, {
    className: "".concat(hostClass, "-header-icon"),
    icon: interaction_arrows_chevronUp,
    noMargin: true,
    title: ""
  })))), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "-content-container__open"), isOpen))
  }, /*#__PURE__*/React.createElement("dd", {
    id: "".concat(id, "-content"),
    className: "".concat(hostClass, "-content"),
    "aria-labelledby": "".concat(id)
  }, children)));
}, defaultProps);
AccordionPresentation.displayName = "AccordionPresentation";

export { AccordionPresentation, defaultProps };
